/* =========================================================
   WARMERY RITUAL QUIZ
   Clean standalone JavaScript
   ========================================================= */

(function () {
  'use strict';

  var QUIZ_ID = 'warmery-ritual-quiz';

  var state = {
    currentQuestion: 0,
    answers: {}
  };


  /* =========================================================
     QUESTIONS
     ========================================================= */

  var questions = [

    {
      title: 'What do you want from this cup?',
      note:
        'There is no wrong answer. Think about the moment you are creating.',
      answers: [
        {
          label: 'A little lift to start the day',
          value: 'energise'
        },
        {
          label: 'A slower, calmer pause',
          value: 'slow'
        },
        {
          label: 'Something warm and comforting',
          value: 'comfort'
        },
        {
          label: 'Something interesting to discover',
          value: 'discover'
        }
      ]
    },

    {
      title: 'What would you most like in your cup?',
      note:
        'Choose what sounds good right now.',
      answers: [
        {
          label: 'Coffee',
          value: 'coffee'
        },
        {
          label: 'Tea',
          value: 'tea'
        },
        {
          label: 'Hot chocolate',
          value: 'chocolate'
        },
        {
          label: 'Surprise me',
          value: 'surprise'
        }
      ]
    },

    {
      title:
        'Which flavour direction sounds most like you?',
      note:
        'Go with your instinct.',
      answers: [
        {
          label: 'Bright and fresh',
          value: 'bright'
        },
        {
          label: 'Deep and distinctive',
          value: 'deep'
        },
        {
          label: 'Soft, floral or gentle',
          value: 'soft'
        },
        {
          label: 'Sweet, warm and cosy',
          value: 'sweet'
        }
      ]
    },

    {
      title:
        'When are you most likely to enjoy it?',
      note:
        'This helps us shape the ritual around your day.',
      answers: [
        {
          label: 'Morning',
          value: 'morning'
        },
        {
          label: 'Afternoon',
          value: 'afternoon'
        },
        {
          label: 'Evening',
          value: 'evening'
        },
        {
          label: 'Whenever I need it',
          value: 'anytime'
        }
      ]
    }

  ];


  /* =========================================================
     PRODUCT DESCRIPTIONS
     ========================================================= */

  var descriptions = {

    coffee_bright:
      'Bright, balanced and uplifting for a cup that gives your day a little more character.',

    coffee_deep:
      'A deeper, more distinctive coffee for people who enjoy a fuller and more comforting cup.',

    coffee_cosy:
      'Soft, sweet and comforting. The sort of coffee that makes an ordinary pause feel a little better.',

    coffee_curious:
      'A characterful speciality coffee for curious drinkers who enjoy discovering something different.',

    tea_fresh:
      'Fresh, bright and refreshing for a lighter pause when you want to reset.',

    tea_classic:
      'Elegant and distinctive for tea drinkers who appreciate a classic cup with character.',

    tea_cosy:
      'Warm, comforting and gently indulgent for slower afternoons and cosy moments.',

    tea_evening:
      'A gentle choice for quieter evenings and moments when you want to slow things down.',

    hot_chocolate:
      'Rich, comforting and wonderfully indulgent when what you really want is a proper little treat.',

    decaf:
      'Mellow coffee comfort without making your evening feel like a morning cup.'

  };


  /* =========================================================
     GET QUIZ
     ========================================================= */

  function getQuiz() {
    return document.getElementById(QUIZ_ID);
  }


  /* =========================================================
     GET PRODUCTS
     ========================================================= */

  function getProducts(quiz) {

    var element =
      document.querySelector(
  '[data-warmery-products]'
);

    if (!element) {
      console.error(
        'Warmery Quiz: product data not found.'
      );

      return {};
    }

    try {

      return JSON.parse(
        element.textContent
      );

    } catch (error) {

      console.error(
        'Warmery Quiz: product data could not be read.',
        error
      );

      return {};
    }
  }


  /* =========================================================
     SCREEN CONTROL
     ========================================================= */

  function showScreen(
    quiz,
    screenName
  ) {

    var screens =
      quiz.querySelectorAll(
        '[data-warmery-screen]'
      );

    screens.forEach(
      function (screen) {

        screen.hidden =
          screen.getAttribute(
            'data-warmery-screen'
          ) !== screenName;

      }
    );
  }


  /* =========================================================
     START
     ========================================================= */

  function startQuiz(quiz) {

    state.currentQuestion = 0;
    state.answers = {};

    showScreen(
      quiz,
      'questions'
    );

    renderQuestion(quiz);
  }


  /* =========================================================
     RENDER QUESTION
     ========================================================= */

  function renderQuestion(quiz) {

    var question =
      questions[
        state.currentQuestion
      ];

    var container =
      quiz.querySelector(
        '[data-warmery-question]'
      );

    if (!container || !question) {
      return;
    }

    var html = '';

    html +=
      '<div class="warmery-quiz__question">';

    html +=
      '<h2 class="warmery-quiz__question-title">' +
      escapeHtml(question.title) +
      '</h2>';

    html +=
      '<p class="warmery-quiz__question-note">' +
      escapeHtml(question.note) +
      '</p>';

    html +=
      '<div class="warmery-quiz__answers">';

    question.answers.forEach(
      function (answer) {

        html +=
          '<button ' +
          'type="button" ' +
          'class="warmery-quiz__answer" ' +
          'data-warmery-answer="' +
          escapeAttribute(answer.value) +
          '">' +
          escapeHtml(answer.label) +
          '</button>';

      }
    );

    html += '</div>';

    html += '</div>';

    container.innerHTML = html;


    var progressText =
      quiz.querySelector(
        '[data-warmery-progress-text]'
      );

    var progressBar =
      quiz.querySelector(
        '[data-warmery-progress-bar]'
      );

    var backButton =
      quiz.querySelector(
        '[data-warmery-back]'
      );


    if (progressText) {

      progressText.textContent =
        'Question ' +
        (state.currentQuestion + 1) +
        ' of ' +
        questions.length;
    }


    if (progressBar) {

      progressBar.style.width =
        (
          (
            state.currentQuestion + 1
          ) /
          questions.length *
          100
        ) + '%';
    }


    if (backButton) {

      backButton.hidden =
        state.currentQuestion === 0;
    }
  }


  /* =========================================================
     ANSWER
     ========================================================= */

  function handleAnswer(
    quiz,
    value
  ) {

    state.answers[
      state.currentQuestion
    ] = value;


    if (
      state.currentQuestion ===
      questions.length - 1
    ) {

      showResult(quiz);

      return;
    }


    state.currentQuestion += 1;

    renderQuestion(quiz);
  }


  /* =========================================================
     BACK
     ========================================================= */

  function handleBack(quiz) {

    if (
      state.currentQuestion === 0
    ) {
      return;
    }

    state.currentQuestion -= 1;

    renderQuestion(quiz);
  }


  /* =========================================================
     DETERMINE RECOMMENDATION
     ========================================================= */

  function determineRecommendation() {

    var mood =
      state.answers[0];

    var drink =
      state.answers[1];

    var flavour =
      state.answers[2];

    var time =
      state.answers[3];


    /* Chocolate */

    if (
      drink === 'chocolate'
    ) {

      return {

        product:
          'hot_chocolate',

        title:
          'You are made for a little chocolate comfort.',

        intro:
          'Your answers point towards a warmer, more indulgent ritual. This is less about rushing through a drink and more about enjoying the moment.'

      };
    }


    /* Evening */

    if (
      time === 'evening' &&
      drink !== 'coffee'
    ) {

      return {

        product:
          'tea_evening',

        title:
          'Your ritual belongs to the quieter part of the day.',

        intro:
          'You seem to enjoy a gentler pace, particularly when the day is winding down.'

      };
    }


    /* Tea */

    if (
      drink === 'tea'
    ) {

      if (
        flavour === 'bright'
      ) {

        return {

          product:
            'tea_fresh',

          title:
            'Your cup needs a little lift.',

          intro:
            'Fresh and bright sounds right for you. Something refreshing without making the ritual feel complicated.'

        };
      }


      if (
        flavour === 'soft'
      ) {

        return {

          product:
            'tea_evening',

          title:
            'You like your rituals gentle.',

          intro:
            'A softer cup suits the way you like to pause, especially when the pace of the day starts to ease.'

        };
      }


      if (
        flavour === 'deep'
      ) {

        return {

          product:
            'tea_classic',

          title:
            'You appreciate a tea with character.',

          intro:
            'You seem to prefer a more distinctive cup with enough character to make the ritual feel special.'

        };
      }


      return {

        product:
          'tea_cosy',

        title:
          'Your ideal ritual is warm and comforting.',

        intro:
          'You are drawn towards the cosy side of tea, where the cup becomes part of the moment rather than simply a drink.'

      };
    }


    /* Coffee */

    if (
      drink === 'coffee'
    ) {

      if (
        flavour === 'bright'
      ) {

        return {

          product:
            'coffee_bright',

          title:
            'You like your mornings bright.',

          intro:
            'A lively, balanced coffee looks like the best match for the way you enjoy starting your day.'

        };
      }


      if (
        flavour === 'deep'
      ) {

        return {

          product:
            'coffee_deep',

          title:
            'You like a coffee with presence.',

          intro:
            'You seem to enjoy depth and character rather than something that simply disappears into the background.'

        };
      }


      if (
        flavour === 'sweet'
      ) {

        return {

          product:
            'coffee_cosy',

          title:
            'You are a cosy coffee person.',

          intro:
            'Warm, sweet and comforting is clearly your direction. Your coffee should feel like a proper pause.'

        };
      }


      return {

        product:
          'coffee_curious',

        title:
          'You have a curious coffee side.',

        intro:
          'You seem open to discovering something a little different, which makes a speciality coffee a natural match.'

      };
    }


    /* Surprise */

    if (
      drink === 'surprise'
    ) {

      if (
        time === 'evening'
      ) {

        return {

          product:
            'tea_evening',

          title:
            'Let us make your evening a little quieter.',

          intro:
            'A gentle tea feels like the best surprise for the time of day you have chosen.'

        };
      }


      if (
        mood === 'discover'
      ) {

        return {

          product:
            'coffee_curious',

          title:
            'Your ritual has a curious streak.',

          intro:
            'You are open to something different, so we have chosen a speciality coffee with plenty of character.'

        };
      }


      if (
        mood === 'comfort'
      ) {

        return {

          product:
            'hot_chocolate',

          title:
            'Sometimes the answer is simply comfort.',

          intro:
            'Your answers suggest that a little indulgence is exactly what the moment calls for.'

        };
      }


      return {

        product:
          'tea_fresh',

        title:
          'A fresh little surprise.',

        intro:
          'We have chosen something bright and refreshing to give your ritual a gentle lift.'

      };
    }


    /* Fallback */

    return {

      product:
        'tea_cosy',

      title:
        'Your ritual is all about comfort.',

      intro:
        'A warm, comforting cup feels like the best match for your answers.'

    };
  }


  /* =========================================================
     COMPLEMENTARY RECOMMENDATIONS
     ========================================================= */

  var complements = {

    coffee_bright: {

      title:
        'Pair it with a slower morning.',

      description:
        'Explore more Warmery coffee and find another cup for a different kind of morning.',

      url:
        '/collections/coffee-for-slower-mornings-and-clearer-thinking'

    },

    coffee_deep: {

      title:
        'Keep the coffee ritual going.',

      description:
        'There is more to discover if you like deeper, more distinctive coffees.',

      url:
        '/collections/coffee-for-slower-mornings-and-clearer-thinking'

    },

    coffee_cosy: {

      title:
        'Make the pause a little cosier.',

      description:
        'Explore Warmery coffee for another comforting moment later in the day.',

      url:
        '/collections/coffee-for-slower-mornings-and-clearer-thinking'

    },

    coffee_curious: {

      title:
        'Keep exploring.',

      description:
        'Discover more speciality coffees from Warmery.',

      url:
        '/collections/coffee-for-slower-mornings-and-clearer-thinking'

    },


    /* IMPORTANT:
       Correct Warmery tea collection */

    tea_fresh: {

      title:
        'Find another kind of pause.',

      description:
        'Explore more Warmery teas for different moments throughout the day.',

      url:
        '/collections/soothing-tea-pauses'

    },

    tea_classic: {

      title:
        'Discover more tea with character.',

      description:
        'Explore more Warmery tea for your next cup.',

      url:
        '/collections/soothing-tea-pauses'

    },

    tea_cosy: {

      title:
        'Lean into the cosy feeling.',

      description:
        'Explore more comforting Warmery teas.',

      url:
        '/collections/soothing-tea-pauses'

    },

    tea_evening: {

      title:
        'Make the evening yours.',

      description:
        'Explore more gentle options for slower evenings.',

      url:
        '/collections/soothing-tea-pauses'

    },


    hot_chocolate: {

      title:
        'Complete the comfort.',

      description:
        'Explore more Warmery treats for slower moments.',

      url:
        '/collections/hot-chocolates'

    },

    decaf: {

      title:
        'Keep evenings easy.',

      description:
        'Explore more Warmery coffee for slower moments.',

      url:
        '/collections/coffee-for-slower-mornings-and-clearer-thinking'

    }

  };


  /* =========================================================
     SHOW COMPLEMENT
     ========================================================= */

  function showComplement(
    quiz,
    productKey
  ) {

    var complement =
      quiz.querySelector(
        '[data-warmery-complement]'
      );

    var title =
      quiz.querySelector(
        '[data-warmery-complement-title]'
      );

    var description =
      quiz.querySelector(
        '[data-warmery-complement-description]'
      );

    var link =
      quiz.querySelector(
        '[data-warmery-complement-link]'
      );

    var item =
      complements[productKey];


    if (
      !item ||
      !complement
    ) {

      if (complement) {
        complement.hidden = true;
      }

      return;
    }


    if (title) {
      title.textContent =
        item.title;
    }


    if (description) {
      description.textContent =
        item.description;
    }


    if (link) {

      link.href =
        item.url;

      link.removeAttribute(
        'data-warmery-quiz-action'
      );
    }


    complement.hidden = false;
  }


  /* =========================================================
     SHOW RESULT
     ========================================================= */

  function showResult(quiz) {

    var recommendation =
      determineRecommendation();

    var products =
      getProducts(quiz);

    var product =
      products[
        recommendation.product
      ];


    if (!product) {

      showMissingProductResult(
        quiz,
        recommendation
      );

      return;
    }


    var title =
      quiz.querySelector(
        '[data-warmery-result-title]'
      );

    var intro =
      quiz.querySelector(
        '[data-warmery-result-intro]'
      );

    var image =
      quiz.querySelector(
        '[data-warmery-product-image]'
      );

    var productTitle =
      quiz.querySelector(
        '[data-warmery-product-title]'
      );

    var price =
      quiz.querySelector(
        '[data-warmery-product-price]'
      );

    var description =
      quiz.querySelector(
        '[data-warmery-product-description]'
      );

    var link =
      quiz.querySelector(
        '[data-warmery-product-link]'
      );


    if (title) {
      title.textContent =
        recommendation.title;
    }


    if (intro) {
      intro.textContent =
        recommendation.intro;
    }


    if (
      image &&
      product.image
    ) {

      image.src =
        product.image;

      image.alt =
        product.title;

      image.hidden = false;

    } else if (image) {

      image.hidden = true;
    }


    if (productTitle) {

      productTitle.textContent =
        product.title;
    }


    if (price) {

      price.textContent =
        product.price || '';
    }


    if (description) {

      description.textContent =
        descriptions[
          recommendation.product
        ] || '';
    }


    if (link) {

      link.href =
        product.url || '#';
    }


    showComplement(
      quiz,
      recommendation.product
    );


    showScreen(
      quiz,
      'result'
    );


    /* Start the result at the top */

    var windowElement =
      quiz.querySelector(
        '.warmery-quiz__window'
      );

    if (windowElement) {
      windowElement.scrollTop = 0;
    }
  }


  /* =========================================================
     MISSING PRODUCT
     ========================================================= */

  function showMissingProductResult(
    quiz,
    recommendation
  ) {

    var title =
      quiz.querySelector(
        '[data-warmery-result-title]'
      );

    var intro =
      quiz.querySelector(
        '[data-warmery-result-intro]'
      );

    var product =
      quiz.querySelector(
        '[data-warmery-product]'
      );

    var complement =
      quiz.querySelector(
        '[data-warmery-complement]'
      );


    if (title) {

      title.textContent =
        recommendation.title;
    }


    if (intro) {

      intro.textContent =
        recommendation.intro +
        ' We just need to connect this quiz result to its Warmery product in the Theme Editor.';
    }


    if (product) {

      product.innerHTML =

        '<div style="grid-column:1/-1;text-align:center;">' +

        '<p class="warmery-quiz__result-label">' +

        'Product not selected' +

        '</p>' +

        '<h3>' +

        'Choose the matching product in the quiz settings.' +

        '</h3>' +

        '<p>' +

        'Open the Warmery ritual quiz section in the Theme Editor and select a product for this result.' +

        '</p>' +

        '</div>';
    }


    if (complement) {

      complement.hidden = true;
    }


    showScreen(
      quiz,
      'result'
    );
  }


  /* =========================================================
     RESET
     ========================================================= */

  function resetQuiz(quiz) {

    state.currentQuestion = 0;

    state.answers = {};

    showScreen(
      quiz,
      'intro'
    );


    var windowElement =
      quiz.querySelector(
        '.warmery-quiz__window'
      );

    if (windowElement) {
      windowElement.scrollTop = 0;
    }
  }


  /* =========================================================
     OPEN
     ========================================================= */

  function openQuiz(quiz) {

    if (!quiz) {
      return;
    }

    quiz.classList.add(
      'is-open'
    );

    quiz.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'warmery-quiz-open'
    );

    document.body.style.overflow =
      'hidden';
  }


  /* =========================================================
     CLOSE
     ========================================================= */

  function closeQuiz(quiz) {

    if (!quiz) {
      return;
    }


    quiz.classList.remove(
      'is-open'
    );

    quiz.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'warmery-quiz-open'
    );

    document.body.style.overflow =
      '';


    /*
     * Remove the quiz hash from the address bar
     * without reloading the page.
     */

    if (
      window.location.hash ===
      '#warmery-ritual-quiz'
    ) {

      history.replaceState(
        null,
        document.title,
        window.location.pathname +
        window.location.search
      );
    }
  }


  /* =========================================================
     HANDLE QUIZ CLICK
     ========================================================= */

  function handleQuizClick(
    event,
    quiz
  ) {

    var target =
      event.target.closest(
        'button, a'
      );

    if (!target) {
      return;
    }


    /* CLOSE */

    if (
      target.matches(
        '[data-warmery-quiz-close]'
      )
    ) {

      event.preventDefault();
      event.stopPropagation();

      closeQuiz(quiz);

      return;
    }


    /* START */

    if (
      target.matches(
        '[data-warmery-start]'
      )
    ) {

      event.preventDefault();
      event.stopPropagation();

      resetQuiz(quiz);

      startQuiz(quiz);

      return;
    }


    /* ANSWER */

    if (
      target.matches(
        '[data-warmery-answer]'
      )
    ) {

      event.preventDefault();

      handleAnswer(
        quiz,
        target.getAttribute(
          'data-warmery-answer'
        )
      );

      return;
    }


    /* BACK */

    if (
      target.matches(
        '[data-warmery-back]'
      )
    ) {

      event.preventDefault();

      handleBack(quiz);

      return;
    }


    /* RESTART */

    if (
      target.matches(
        '[data-warmery-restart]'
      )
    ) {

      event.preventDefault();

      resetQuiz(quiz);

      return;
    }


    /*
     * Continue browsing should close
     * rather than behave like a normal
     * quiz action.
     */

    if (
      target.matches(
        '[data-warmery-close-result]'
      )
    ) {

      event.preventDefault();

      closeQuiz(quiz);

      return;
    }


    /*
     * Product and Discover more links
     * are allowed to navigate normally.
     */
  }


  /* =========================================================
     OUTSIDE CLICK
     ========================================================= */

  function handleOutsideClick(
    event,
    quiz
  ) {

    if (
      event.target ===
      quiz.querySelector(
        '[data-warmery-quiz-overlay]'
      )
    ) {

      closeQuiz(quiz);
    }
  }


  /* =========================================================
     TRIGGER FROM WEBSITE
     ========================================================= */

  function handleTriggerClick(
    event
  ) {

    var trigger =
      event.target.closest(
        'a, button'
      );

    if (!trigger) {
      return;
    }


    var href =
      trigger.getAttribute(
        'href'
      );


    /*
     * Explicit trigger:
     *
     * data-warmery-ritual-trigger
     */

    if (
      trigger.hasAttribute(
        'data-warmery-ritual-trigger'
      )
    ) {

      event.preventDefault();

      var quiz =
        getQuiz();

      if (!quiz) {
        return;
      }

      resetQuiz(quiz);

      openQuiz(quiz);

      return;
    }


    /*
     * Hash trigger:
     *
     * #warmery-ritual-quiz
     */

    if (
      href &&
      href.indexOf(
        '#warmery-ritual-quiz'
      ) !== -1
    ) {

      event.preventDefault();

      var quiz =
        getQuiz();

      if (!quiz) {
        return;
      }

      resetQuiz(quiz);

      openQuiz(quiz);
    }
  }


  /* =========================================================
     ESCAPE
     ========================================================= */

  function handleEscape(
    event
  ) {

    if (
      event.key !== 'Escape'
    ) {
      return;
    }

    var quiz =
      getQuiz();

    if (
      quiz &&
      quiz.classList.contains(
        'is-open'
      )
    ) {

      closeQuiz(quiz);
    }
  }


  /* =========================================================
     INITIALISE
     ========================================================= */

  function initialise() {

    var quiz =
      getQuiz();

    if (!quiz) {
      return;
    }


    /*
     * Quiz click handling.
     */

    if (
      !quiz.dataset.warmeryQuizBound
    ) {

      quiz.dataset.warmeryQuizBound =
        'true';

      quiz.addEventListener(
        'click',
        function (event) {

          handleQuizClick(
            event,
            quiz
          );

          handleOutsideClick(
            event,
            quiz
          );

        }
      );
    }


    /*
     * Website trigger.
     */

    if (
      !window.warmeryQuizTriggerBound
    ) {

      window.warmeryQuizTriggerBound =
        true;

      document.addEventListener(
        'click',
        handleTriggerClick
      );
    }


    /*
     * Escape.
     */

    if (
      !window.warmeryQuizEscapeBound
    ) {

      window.warmeryQuizEscapeBound =
        true;

      document.addEventListener(
        'keydown',
        handleEscape
      );
    }


    /*
     * If somebody loads the URL directly
     * with the quiz hash, open the quiz.
     */

    if (
      window.location.hash ===
      '#warmery-ritual-quiz'
    ) {

      resetQuiz(quiz);

      openQuiz(quiz);
    }
  }


  /* =========================================================
     DOM READY
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      initialise();

    }
  );


  /* =========================================================
     ESCAPE HTML
     ========================================================= */

  function escapeHtml(value) {

    return String(value)

      .replace(
        /&/g,
        '&amp;'
      )

      .replace(
        /</g,
        '&lt;'
      )

      .replace(
        />/g,
        '&gt;'
      )

      .replace(
        /"/g,
        '&quot;'
      )

      .replace(
        /'/g,
        '&#039;'
      );
  }


  function escapeAttribute(value) {

    return escapeHtml(value);
  }


})();